import * as React from 'react';
import './ResetPass.css';
import { useDispatch } from 'react-redux';
import { resetPassword } from './actions';
import Input from '../../components/Input/Input';
import { Controller, useForm } from 'react-hook-form';
import Button from '../../components/Button/Button';
import Text from '../../components/Text/Text';
import Logo from '../../assets/Logo.png';
import { useNavigate } from 'react-router-dom';
import FormItem from '../../components/FormItem/FormItem';
import { useTranslation } from 'react-i18next';
import { CrownOutlined } from '@ant-design/icons';

type FormValues = {
  email: string;
};

const ResetPass = React.memo(() => {
  const { t } = useTranslation('translation');
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<FormValues>({});

  const onSubmit = handleSubmit(({ email }) => {
    dispatch(resetPassword(email));
  });

  const handleRedirectHome = () => {
    navigate('/');
  };

  return (
    <div className="AuthPage">
      <div className="AuthCard">
        <span className="PageHero__eyebrow ResetPass__eyebrow">
          <CrownOutlined /> Fish Hunter
        </span>
        <img className="AuthCard__logo" src={Logo} alt="Fish Hunter" onClick={handleRedirectHome} />
        <Text className="AuthCard__title" size={5} bold>
          {t('password_recovery')}
        </Text>
        <Text className="AuthCard__description" type="secondary" size={2}>
          {t('enter_your_email_address_and_we_will_send_you_a_link_to_restore_your_password')}
        </Text>
        <form className="AuthCard__form" onSubmit={onSubmit}>
          <FormItem error={errors.email?.message}>
            <Controller
              name="email"
              control={control}
              rules={{
                required: t('required'),
                pattern: {
                  value: /\S+@\S+\.\S+/,
                  message: t('entered_value_does_not_match_email_format'),
                },
              }}
              render={({ field }) => (
                <Input
                  placeholder="Email"
                  autoComplete="off"
                  aria-invalid={errors.email?.message ? true : false}
                  {...field}
                />
              )}
            />
          </FormItem>
          <FormItem>
            <Button className="AuthCard__action" type="primary">
              {t('reset')}
            </Button>
          </FormItem>
        </form>
      </div>
    </div>
  );
});

export default ResetPass;
